import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Heart = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M8.98 13.5109L9.06041 13.4391C12.655 10.2285 15 8.05083 15 5.38587C15 3.19565 13.32 1.5 11.15 1.5C10.4329 1.5 9.71588 1.70523 9.09071 2.06931C8.67838 2.30943 8.30602 2.61867 8 2.9837C7.69398 2.61867 7.32162 2.30943 6.90929 2.0693C6.28412 1.70523 5.56706 1.5 4.85 1.5C2.68 1.5 1 3.19565 1 5.38587C1 8.05083 3.34499 10.2285 6.93959 13.4391L7.02 13.5109L8 14.5L8.98 13.5109ZM7.3138 4.5L6.85051 3.94737C6.35906 3.36116 5.58644 3 4.85 3C3.52151 3 2.5 4.01093 2.5 5.38587C2.5 6.24197 2.86602 7.13233 3.80813 8.28924C4.76444 9.4636 6.16436 10.7359 8 12.375C9.83563 10.7359 11.2356 9.4636 12.1919 8.28924C13.134 7.13233 13.5 6.24197 13.5 5.38587C13.5 4.01093 12.4785 3 11.15 3C10.4136 3 9.64094 3.36116 9.14949 3.94737L8.6862 4.5H7.3138Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Heart;
